/**
 * Allowed `party_role` values for GET /contracts/filter_options/parties.
 */
export const CONTRACT_PARTY_ROLES = ['buyer', 'seller'] as const;
